function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M357.396,535.33c0.776,0.042,1.542,0.109,2.329,0.109h177.39c20.75,0,37.627-16.883,37.627-37.627V86.597 c0-20.743-16.877-37.628-37.627-37.628h-177.39c-0.781,0-1.553,0.077-2.329,0.113V0L11.176,46.206v492.311l346.22,47.401V535.33z  M359.726,70.476h177.39c8.893,0,16.125,7.236,16.125,16.126v411.22c0,8.888-7.232,16.127-16.125,16.127h-177.39 c-0.792,0-1.563-0.127-2.329-0.243V382.382h165.125c3.958,0,7.17-3.207,7.17-7.159c0-3.953-3.212-7.165-7.17-7.165H357.396V324.13 h165.125c3.958,0,7.17-3.212,7.17-7.165c0-3.954-3.212-7.161-7.17-7.161H357.396v-42.562h165.125c3.958,0,7.17-3.21,7.17-7.161 c0-3.955-3.212-7.16-7.17-7.16H357.396v-42.973h88.83c3.952,0,7.17-3.207,7.17-7.16c0-3.955-3.218-7.157-7.17-7.157h-88.83V70.711 C358.162,70.599,358.929,70.476,359.726,70.476z M112.112,257.491l-28.851,0.462v90.282l-23.441-0.598v-89.286l-27.066,0.457 v-20.691l79.363-2.079v21.452H112.112z M186.706,350.824l-10.32-21.292c-4.189-8.157-6.877-14.221-10.047-20.941L166,308.57 c-2.344,6.699-5.155,12.657-8.638,20.657l-9.231,20.62l-28.187-0.693l31.643-57.371L121.044,235.8l28.419-0.735l9.705,20.78 c3.349,6.973,5.826,12.595,8.504,19.089l0.327,0.005c2.698-7.43,4.869-12.616,7.73-19.373l9.617-21.443l29.919-0.801l-32.62,57.747 l34.365,60.516L186.706,350.824z M318.1,254.066l-34.477,0.572v98.615l-27.924-0.713v-97.429l-32.2,0.535v-22.539l94.61-2.488 v23.446H318.1z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgTxtExt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "585.918px",
    height: "585.918px",
    viewBox: "0 0 585.918 585.918",
    style: {
      enableBackground: "new 0 0 585.918 585.918"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtExt);
export default __webpack_public_path__ + "static/media/txt_ext.cdbd8b0d.svg";
export { ForwardRef as ReactComponent };